module.exports = __webpack_public_path__ + "static/media/do.79f8bf8c.svg";